/**
 * @desc 查看报警规则详情(旧版)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 主键id */
  id: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.AlertDetailResponse>> {
  return defHttp.get({
    url: '/web/alert/rule/selectById',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.AlertDetailResponse>> {
  return defHttp.get({
    url: '/mock/web/alert/rule/selectById',

    params,
  });
}
